import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TITLES = {
  terms: { title: "Términos y Condiciones", endpoint: "/legal/terms" },
  privacy: { title: "Política de Privacidad", endpoint: "/legal/privacy" },
};

// Renderiza markdown básico (headings, bold, listas, links) sin librería extra
function renderMD(md) {
  const lines = md.split("\n");
  const out = [];
  let list = null;
  const flushList = () => { if (list) { out.push(list); list = null; } };
  const inline = (t) =>
    t
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/`([^`]+)`/g, '<code class="text-xs bg-slate-100 px-1 py-0.5 rounded">$1</code>')
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="text-blue-600 underline" target="_blank" rel="noreferrer">$1</a>')
      .replace(/_(.+?)_/g, "<em>$1</em>");
  lines.forEach((raw, i) => {
    const l = raw.trimEnd();
    if (l.startsWith("# ")) { flushList(); out.push(<h1 key={i} className="text-3xl font-black text-slate-900 mb-3 mt-4">{l.slice(2)}</h1>); }
    else if (l.startsWith("## ")) { flushList(); out.push(<h2 key={i} className="text-xl font-bold text-slate-900 mt-8 mb-3">{l.slice(3)}</h2>); }
    else if (l.startsWith("### ")) { flushList(); out.push(<h3 key={i} className="text-base font-semibold text-slate-800 mt-5 mb-2">{l.slice(4)}</h3>); }
    else if (l.startsWith("- ")) {
      if (!list) list = <ul key={`ul-${i}`} className="list-disc pl-6 space-y-1 text-sm text-slate-700 leading-relaxed" />;
      const items = list.props.children || [];
      list = <ul key={list.key} className={list.props.className}>{[...items, <li key={i} dangerouslySetInnerHTML={{ __html: inline(l.slice(2)) }} />]}</ul>;
    }
    else if (l.trim() === "") { flushList(); }
    else { flushList(); out.push(<p key={i} className="text-sm text-slate-700 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: inline(l) }} />); }
  });
  flushList();
  return out;
}

export default function LegalPage() {
  const { doc } = useParams();
  const meta = TITLES[doc] || TITLES.terms;
  const [content, setContent] = useState("");
  const [updated, setUpdated] = useState("");

  useEffect(() => {
    axios.get(`${API}${meta.endpoint}`)
      .then(({ data }) => { setContent(data.content); setUpdated(data.updated_at); })
      .catch(() => setContent("# Error al cargar\n\nIntenta más tarde."));
  }, [meta.endpoint]);

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800 mb-6">
          <ArrowLeft size={14} /> Volver al inicio
        </Link>
        <div className="prose prose-slate max-w-none">
          {renderMD(content)}
        </div>
        {updated && <div className="mt-8 text-xs text-slate-400 border-t pt-4">Documento vigente al {updated}.</div>}
      </div>
    </div>
  );
}
